export const offlineModeConstants = {
  IS_OFFLINE_MODE_CHANGE: 'IS_OFFLINE_MODE_CHANGE',
  IS_INTERNET_REACHABLE_CHANGE: 'IS_INTERNET_REACHABLE_CHANGE',
  ACTIVITY_STARTED_WITH_OFFLINE_MODE: 'ACTIVITY_STARTED_WITH_OFFLINE_MODE',
  ACTIVITY_OFFLINE_MODE_INVALID: 'ACTIVITY_OFFLINE_MODE_INVALID',
  OFFLINE_MODE_CLEAR: 'OFFLINE_MODE_CLEAR',
  TIMER_STEP_STARTED: 'TIMER_STEP_STARTED',
}
